import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../hooks/useCart';
import Breadcrumb from '../components/Breadcrumb';
import CartItem from '../components/CartItem';
import { useBreadcrumb } from '../contexts/BreadcrumbContext';
import { generateCartBreadcrumb } from '../utils/breadcrumb';
import { Loader2, ShoppingBag } from 'lucide-react';

export default function Cart() {
  const navigate = useNavigate();
  const { items, loading, error, total, updateQuantity, removeFromCart } = useCart();
  const { setItems } = useBreadcrumb();

  useEffect(() => {
    setItems(generateCartBreadcrumb());
  }, [setItems]);

  if (error) {
    return (
      <div className="container mx-auto px-4">
        <Breadcrumb />
        <div className="text-red-600">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4">
      <Breadcrumb />
      
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Shopping Cart</h1>
      </div>

      {loading ? (
        <div className="flex justify-center py-8">
          <Loader2 className="h-8 w-8 animate-spin text-primary-500" />
        </div>
      ) : items.length === 0 ? (
        <div className="text-center py-8">
          <ShoppingBag className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-600 mb-4">Your cart is empty</p>
          <button
            onClick={() => navigate('/shop')}
            className="bg-primary-500 text-white px-6 py-2 rounded-md hover:bg-primary-600 transition-colors"
          >
            Browse Shop
          </button>
        </div>
      ) : (
        <div>
          <div className="space-y-4 mb-8">
            {items.map((item) => (
              <CartItem
                key={item.id}
                item={item}
                onUpdateQuantity={updateQuantity}
                onRemove={removeFromCart}
              />
            ))}
          </div>
          
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="flex justify-between items-center mb-6">
              <span className="text-lg font-semibold">Total</span>
              <span className="text-2xl font-bold text-primary-600">
                ${total.toFixed(2)}
              </span>
            </div>
            
              <div className="space-y-4 mb-8">
                {items.map((item) => (
                  <CartItem
                    key={item.id}
                    item={item}
                    onUpdateQuantity={updateQuantity}
                    onRemove={removeFromCart}
                  />
                ))}
              </div>
              
              <div className="bg-white rounded-lg shadow-md p-6">
                <div className="flex justify-between items-center mb-6">
                  <span className="text-lg font-semibold">Total</span>
                  <span className="text-2xl font-bold text-primary-600">
                    ${total.toFixed(2)}
                  </span>
                </div>
                
                <div className="bg-gray-50 p-4 rounded-md text-center">
                  <p className="text-gray-600 text-sm">
                    Checkout functionality is currently unavailable.
                  </p>
                </div>
              </div>
          </div>
        </div>
      )}
    </div>
  );
}